import React from 'react';

const ShippingInfo = () => {
  return (
    <section className="shipping__section section--padding">
      <div className="container">
        <div className="shipping__section--inner d-flex">
          <div className="shipping__items">
            <div className="shipping__items--icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32.955" height="23.967" viewBox="0 0 32.955 23.967">
                <path d="M29.461,9.992H24.967V4H4A3,3,0,0,0,1,7V23.473H4a4.494,4.494,0,0,0,8.988,0h8.988a4.494,4.494,0,1,0,8.988,0h3v-7.49ZM8.49,25.72a2.247,2.247,0,1,1,2.247-2.247A2.244,2.244,0,0,1,8.49,25.72ZM28.712,12.239l2.936,3.745H24.967V12.239ZM26.465,25.72a2.247,2.247,0,1,1,2.247-2.247A2.244,2.244,0,0,1,26.465,25.72Z" transform="translate(-1 -4)" fill="currentColor" opacity="0.73" />
              </svg>
            </div>
            <div className="shipping__items--content text-center">
              <h2 className="shipping__items--title h3">Free Shipping</h2>
              <p className="shipping__items--desc"></p>
            </div>
          </div>
          <div className="shipping__items">
            <div className="shipping__items--icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="27.63" height="38.407" viewBox="0 0 27.63 38.407">
                <path d="M17.615,6.106V1L10.808,7.808l6.808,6.808V9.509A10.219,10.219,0,0,1,27.826,19.721a9.991,9.991,0,0,1-1.191,4.765l2.485,2.485a13.591,13.591,0,0,0-11.5-20.865Zm0,23.826A10.219,10.219,0,0,1,7.4,19.721,9.991,9.991,0,0,1,8.6,14.955L6.11,12.471a13.591,13.591,0,0,0,11.5,20.865v5.106l6.808-6.808-6.808-6.808Z" transform="translate(-3.8 -0.517)" fill="currentColor" strokeWidth="0.4" opacity="0.7" />
              </svg>
            </div>
            <div className="shipping__items--content text-center">
              <h2 className="shipping__items--title h3">Free Returns</h2>
              <p className="shipping__items--desc"></p>
            </div>
          </div>
          <div className="shipping__items">
            <div className="shipping__items--icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="27.787" height="22.735" viewBox="0 0 27.787 22.735">
                <path d="M26.261,3H3.526A2.534,2.534,0,0,0,1,5.526V23.209a2.534,2.534,0,0,0,2.526,2.526H26.261a2.534,2.534,0,0,0,2.526-2.526V5.526A2.534,2.534,0,0,0,26.261,3ZM14.894,13.1H3.526V10.578H14.894Zm0-5.052H3.526V5.526H14.894Z" transform="translate(-1 -3)" fill="currentColor" opacity="0.7" />
              </svg>
            </div>
            <div className="shipping__items--content text-center">
              <h2 className="shipping__items--title h3">Secure Payment</h2>
              <p className="shipping__items--desc"></p>
            </div>
          </div>
          <div className="shipping__items">
            <div className="shipping__items--icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22.143" viewBox="0 0 25 22.143">
                <path d="M81.251,82.1c2.151,0,3.12-.959,3.12-2.149S83.4,77.8,81.251,77.8a6.99,6.99,0,0,0-4.694,1.8,3.4,3.4,0,0,0-1.609-.414,3.306,3.306,0,0,0-1.54.385A7,7,0,0,0,68.746,77.8c-2.157,0-3.12.964-3.12,2.149s.96,2.149,3.12,2.149h5.189V99.943H76.06V82.1Zm0-2.862c.709,0,1.554.126,1.554.713s-.846.721-1.554.721H77.7l-.029-.066A5.35,5.35,0,0,1,81.251,79.236ZM72.206,80.67H68.749c-.709,0-1.566-.128-1.566-.721s.854-.713,1.566-.713a5.33,5.33,0,0,1,3.526,1.321Zm-9.706,3.5v2.87H73.44v-4.3H64.066A1.505,1.505,0,0,0,62.5,84.174Zm1.566,14.333a1.5,1.5,0,0,0,1.563,1.434H73.44V88.472H64.066ZM85.934,82.74H76.628v4.306H87.5V84.174A1.507,1.507,0,0,0,85.934,82.74Zm-9.306,17.2h7.743a1.507,1.507,0,0,0,1.566-1.434V88.472H76.628Z" transform="translate(-62.5 -77.8)" fill="currentColor" opacity="0.7" />
              </svg>
            </div>
            <div className="shipping__items--content text-center">
              <h2 className="shipping__items--title h3">Gift Service</h2>
              <p className="shipping__items--desc"></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShippingInfo;
